import Container from "hardcover-ui/components/Container";
import PromptHeader from "./PromptHeader";
import { PageSerializersPromptsLayout } from "types/serializers";

export interface Props {
  prompt: PageSerializersPromptsLayout;
  children: React.ReactElement;
}

export default function PromptPage({ prompt, children }: Props) {
  return (
    <>
      <Container size="sm" variant="layout">
        <PromptHeader prompt={prompt} />
      </Container>
      {children}
    </>
  );
}
